import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '@components/template/Page';
import BriefingTable from './BriefingTable';
import PageHeader from '@components/organisms/PageHeader/index';
import ShowChartIcon from '@material-ui/icons/ShowChart';
// import ProfileDetails from './ProfileDetails';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Admin = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Admin">
      <Container maxWidth="lg">
        <PageHeader
          title="종목 브리핑"
          subTitle="종목 브리핑 등록/삭제"
          icon={<ShowChartIcon fontSize="large" />}
        />
        <BriefingTable />
      </Container>
    </Page>
  );
};

export default Admin;
